import {ColorsType} from '../../../../styles';
import {
  RadioButtonSize,
  RadioButtonState,
} from '../../RadioButton/RadioButton/radioButton_types.web';

type RadioButtonIconProps = {
  id?: string;
  className?: string;
  size: RadioButtonSize;
  colors: ColorsType;
  state: RadioButtonState;
};

const pathDsBySize = {
  medium: [
    'M10.8052 16.2959L7.5 12.8084L8.55106 11.7045L10.8052 14.0811L15.7035 8.91309L16.7546 10.024L10.8052 16.2959Z',
  ],
  small: [
    'M7.2036 10.8639L5.00012 8.53889L5.70083 7.80295L7.2036 9.38733L10.4691 5.94202L11.1699 6.68264L7.2036 10.8639Z',
  ],
};

const checkrectBySize = {
  medium: {
    x: '3',
    y: '3',
    width: '18',
    height: '18',
    rx: '8.99998',
  },
  small: {
    x: '2.00012',
    y: '2',
    width: '12',
    height: '12',
    rx: '6',
  },
};

const disableContainerrectBySize = {
  medium: {
    x: '4',
    y: '4',
    width: '16',
    height: '16',
    rx: '8',
  },
  small: {
    x: '2.50012',
    y: '2.50006',
    width: '11',
    height: '11',
    rx: '5.5',
  },
};

const disablerectBySize = {
  medium: {
    x: '7.49963',
    y: '7.49976',
    width: '9.00037',
    height: '9.00037',
    rx: '4.50018',
  },
  small: {
    x: '4.99976',
    y: '4.99988',
    width: '6.00024',
    height: '6.00024',
    rx: '3.00012',
  },
};

const RadioButtonIcon = (props: RadioButtonIconProps) => {
  const {id, className, size, colors, state} = props;
  const paths = pathDsBySize[size];
  const rectAttrs =
    state === 'active'
      ? checkrectBySize[size]
      : disableContainerrectBySize[size];
  const svgSize = size === 'medium' ? 24 : 16;
  return (
    <svg
      id={id}
      className={className}
      width={svgSize}
      height={svgSize}
      viewBox={`0 0 ${svgSize} ${svgSize}`}
      fill="none">
      <rect
        {...rectAttrs}
        stroke={
          state !== 'active'
            ? state !== 'hover'
              ? colors.neutral400
              : colors.primary700
            : undefined
        }
        fill={state === 'active' ? colors.primary700 : colors.neutral100}
        strokeWidth="2"
      />
      {state === 'active' ? (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d={paths[0]}
          fill={colors.neutral100}
        />
      ) : null}
      {state === 'disable' ? (
        <rect {...disablerectBySize[size]} fill={colors.neutral400} />
      ) : null}
    </svg>
  );
};

export default RadioButtonIcon;
